module.exports = __webpack_public_path__ + "2042ef5a08bf9d082dcd9dc0cf911e0b.pdf";